import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { DefaultModal } from "../default-modal/default-modal";
import defaultStyles from "../default-modal/default-modal.less";
import { ModalSizeTypes } from "@enums/modal-size-types";

type LoadingModalProps = {
    onModalClose: () => void;
    title: string;
    message: string;
    buttonText: string;
}

export const LoadingModal = (props: LoadingModalProps) => {
    const { onModalClose, title, message, buttonText } = props;

    return (
        <DefaultModal
            automationId="loading-modal"
            ariaLabelledBy="loading-title"
            onHide={onModalClose}
            backdrop={"static"}
            keyboard={false}
            isMaxWidth={false}
            size={ModalSizeTypes.SMALL}
        >
            <Modal.Header id={"loading-title"} closeButton>
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <span className={defaultStyles.description}>
                    {message}
                </span>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="primary" onClick={onModalClose}>{buttonText}</Button>
            </Modal.Footer>
        </DefaultModal>
    );
};